import { Box, Skeleton } from "@mui/material";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { spacing } from "@/styles/nawy-theme/foundation/spacing";
import { radius } from "@/styles/nawy-theme/foundation/radius";

interface SalesCardSkeletonProps {
  count?: number;
}

export const SalesCardSkeleton = ({ count = 2 }: SalesCardSkeletonProps) => {
  const screen = useScreenSize();

  const renderSingleCardSkeleton = (index: number) => (
    <Box
      key={index}
      sx={{
        backgroundColor: "#F9F9F9",
        borderRadius: radius.xl,
        padding: spacing.md,
        display: "flex",
        flexDirection: "column",
        gap: spacing.md,
        width: "100%",
      }}
    >
      {/* Section 1: Title and Subtitle Skeleton */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: spacing.xxxs }}>
        <Skeleton
          variant="text"
          width="70%"
          height={24}
          sx={{ fontSize: "1rem" }}
        />
        <Skeleton
          variant="text"
          width="50%"
          height={20}
          sx={{ fontSize: "0.875rem" }}
        />
      </Box>

      {/* Section 2: Grid of Data Fields Skeleton */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: spacing.md,
          rowGap: spacing.md,
          columnGap: spacing["2xl"],
          width: "100%",
        }}
      >
        {Array.from({ length: 6 }).map((_, fieldIndex) => (
          <Box
            key={fieldIndex}
            sx={{
              width: screen.isMobile ? "134px" : "159px",
              display: "flex",
              flexDirection: "column",
              gap: spacing.xxs,
            }}
          >
            <Skeleton
              variant="text"
              width="80%"
              height={16}
              sx={{ fontSize: "0.75rem" }}
            />
            <Skeleton
              variant="text"
              width="60%"
              height={16}
              sx={{ fontSize: "0.75rem" }}
            />
          </Box>
        ))}
      </Box>

      {/* Section 3: Sales Link Button Skeleton */}
      <Box>
        <Skeleton
          variant="rectangular"
          width={100}
          height={32}
          sx={{ borderRadius: radius.md }}
        />
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {Array.from({ length: count }).map((_, index) =>
        renderSingleCardSkeleton(index)
      )}
    </Box>
  );
};
